import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 14.6667V20L24 24M32 20C32 21.5759 31.6896 23.1363 31.0866 24.5922C30.4835 26.0481 29.5996 27.371 28.4853 28.4853C27.371 29.5996 26.0481 30.4835 24.5922 31.0866C23.1363 31.6896 21.5759 32 20 32C18.4241 32 16.8637 31.6896 15.4078 31.0866C13.9519 30.4835 12.629 29.5996 11.5147 28.4853C10.4004 27.371 9.5165 26.0481 8.91345 24.5922C8.31039 23.1363 8 21.5759 8 20C8 16.8174 9.26428 13.7652 11.5147 11.5147C13.7652 9.26428 16.8174 8 20 8C23.1826 8 26.2348 9.26428 28.4853 11.5147C30.7357 13.7652 32 16.8174 32 20Z",
		stroke: "#7F8083",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClock;
